const zh = {
  home: "首页",
  logout: "退出登录",
  fontsize: "字体大小",
  oops404: "哎呀!",
  info404: "请检查您输入的URL是否正确，或单击下面的按钮返回首页。",
  returnhome404: "返回首页",
  errormsg404: "站长说你不能进入这个页面。。。",
  login: {
    title: "聚能谷设备服务",
    accounttip: "请输入账号",
    passwordtip: "请输入密码",
    codetip: "请输入验证码",
    loginbt: "登录",
    pwderror: "密码不能少于6位数",
    codeerror: "输入的验证码不正确",
    logini: "登录中..."
  },
  spread: {
    faulttype: "故障指示器",
    edgetype: "边缘子站",
    daysoe: "今日SOE",
    all: "全部",
    null_value: "空值",
    worth_it: "有值",
    not_upgraded: "未升级",
    upgrading: "升级中",
    upgrade_uccessful: "升级成功",
    upgrade_failed: "升级失败",
    upgrade_nstructions: "升级说明",
    upgrade_time: "升级时间",
    onlinetit: "在线",
    offlinetit: "离线",
    faulttit: "故障",
    devicetabletit: "设备信息",
    notit: "否",
    yestit: "是",
    devicetab: {
      serial: "序号",
      linename: "线路名称",
      devname: "设备名称",
      terid: "终端ID",
      manu: "厂家",
      tername: "终端名称",
      devstate: "设备状态",
      devtype: "设备类型",
      devmodel: "设备型号",
      operat: "是否投运",
      can_lb: "录波",
      pointtype: "点表类型",
      time: "在线时间",
      Belonging: "所属馈线",
      position: "安装位置",
      Operationtime: "投运时间",
      longitude: "部署经度",
      latitude: "部署纬度",
      desc: "描述",
      upttime: "更新时间",
      heartbeat_time: "在线时间",
      create_time: "创建时间"
    },
    lineeventtit: "近7天路线事件",
    organizationtit: "区域组织列表",
    alarmnotification: "SOE告警通知",
    soealarmtab: {
      serial: "序号",
      circuit: "线路",
      alarmcontent: "告警内容"
    },
    circuittit: "线路",
    zonetit: "区段",
    content: "内容",
    time: "时间",
    detail: "查看详情",
    cancellation: "取 消",
    determine: "确 定",
    soewarning: "请选择至少一条信息",
    soesuccess: "已确认通知"
  },
  detection: {
    line: {
      title: "故障指示器系统图",
      datatit: "暂无数据"
    }
  },
  publics: {
    add: "新增",
    edit: "编辑",
    save: "保存",
    operation: "操作",
    detail: "详情",
    Remarks: "备注",
    Attachment: "附件",
    report: "报告",
    delete: "删除",
    batchdeletion: "批量删除",
    querybtn: "查询",
    resetbtn: "重置",
    select_file: "选取文件",
    export_data: "导出数据",
    collect: "汇集",
    gather: "采集",
    telemetry: "遥测",
    remote_signaling: "遥信",
    constant_value: "定值",
    wireless: "无线",
    upgrade: "升级",
    termination: "终止",
    upload_program: "上传程序",
    upgrade_tatus: "升级状态",
    real_time_refresh_of_upgrade_progress: "实时刷新升级进度",
    upgrade_progress: "升级进度",
    total_frames: "总帧数",
    has_been_sent: "已发送",
    continued_transmission: "续传",
    log: "日志",
    fixed_value_log: "定值日志",
    upgrade_log: "升级日志",
    application_type: "程序类型",
    program_version: "程序版本",
    program: "程序",
    file_size: "文件大小",
    associated_account: "所属账号",
    project_affiliation: "所属项目",
    province_city: "所属省市",
    detailed_address: "详细地址",
    line_topology_diagram: "线路拓扑图",
    only_one_file_can_be_uploaded: "只能上传一个文件",
    are_you_sure_to_continue_the_file_upgrade: "确定续传文件升级吗",
    please_wait_for_device_upgrade: "已下发,请等待设备升级",
    please_wait_for_device_restart: "已下发,请等待设备重启",
    Please_wait_for_the_device_to_terminate_the_upgrade: "已下发,请等待设备终止升级",
    currently: "当前已选择",
    devices_have_been_selected: "个设备",
    do_you_want_to_upgrade: "是否升级",
    please_select_at_least_one_device: "请选择至少一个设备",
    please_upload_the_upgrade_program: "请上传升级程序",
    point_number_cannot_be_empty: "点号不能为空",
    read_successfully: "读取成功，请刷新表格（数据将在两分钟内更新完成，如刷新不成功请重试）",
    refresh_successful: "刷新成功",
    please_read_and_refresh_the_data_before_presetting: "请先读取并刷新数据后再预置",
    The_fixed_value_parameter_of_device: "设备",
    cannot_be_empty: "的定值参数不能为空",
    Issued_to_device: "已下发给设备",
    Time_synchronization: "对时",
    calibration_time: "校准时间",
    read: "读取",
    settings: "设置",
    Select_date_and_time: "选择日期时间",
    heartbeat_time: "心跳时间（秒）",
    Please_enter_the_heartbeat_time: "请输入心跳时间",
    Total_call_time: "总召时间（分）",
    Please_enter_the_total_call_time: "请输入总召时间",
    Update_Beidou_position: "更新北斗位置",
    Heartbeat: "1、心跳、总召皆为全系统配置。",
    Heartbeat2: "2、对时默认为系统时间，选择时间已选择为准，设备默认当前账号所有设备，选择设备已选择为准。",
    Corresponding_project: "对应项目",
    Substation_name: "变电站名称",
    Location_updated_successfully: "更新位置成功",
    Total_devices_under_current_account: "当前账号下总设备",
    location_update_successful: "个，更新位置成功",
    failure: "个，失败",
    total_progress: "个，总进度",
    The_value_cannot_be_empty: "值不能为空",
    Please_enter_a_numerical_value: "请输入数字值",
    Currently_all_devices_under_the_account: "当前为账号下所有设备",
    Do_you_want_to_issue_timing_commands: "是否下发对时命令",
    please_wait_for_the_device_to_synchronize: "已下发,请等待设备对时",
    Setup_successful: "设置成功",
    Determine_the_updated_Beidou_position: "确定更新当前账号下所有设备北斗位置",
    Get_all_devices: "获取所有设备",
    Failed_to_retrieve_all_devices: "获取所有设备失败",
    Update_completed: "更新完毕",
    Project_Name: "项目名称",
    Are_you_sure_to_add_a_single_cable_device: "确定添加单个电缆设备？",
    Not_sent_reason: "未发送，原因：",
    Manual_judgment: "人工判定",
    text_message: "短信",
    Manually_processed: "人工已处理",
    Unprocessed_manually: "人工未处理",
    Remarks_Results: "备注结果",
    It_is_unclear_whether_this_malfunction_has_occurred: "不明确是否发生此故障",
    Please_enter_content: "请输入内容",
    Please_enter_the_name_the_personnel: "请输入人员姓名",
    Please_select_the_remark_result: "请选择备注结果",
    Please_enter_the_processing_content: "请输入处理内容",
    Fault_information: "故障信息",
    affiliated_group: "所属集团",
    Fault_Type: "故障类型",
    fault_time: "故障时间",
    Fault_file: "故障文件",
    Creation_Time: "创建时间",
    manual_processing: "人工处理",
    handler: "处理人",
    fault_line: "故障线路",
    processing_time: "处理时间",
    fault_location: "故障位置",
    Fault_interval: "故障区间",
    placeholder: "请选择",
    fault_phase: "故障相",
    and: "到",
    between: "之间",
    process: "处理",
    save: "保存",
    Equipment_issuance: "设备下发",
    Substation_topology_diagram: "变电站拓扑图",
    province: "省",
    Monday: "周一",
    Tuesday: "周二",
    Wednesday: "周三",
    Thursday: "周四",
    Friday: "周五",
    Saturday: "周六",
    Sunday: "周日",
    Notification_period: "通知时段",
    Start_time: "开始时间",
    End_time: "结束时间",
    Select_a_time_range: "选择时间范围",
    Personnel_number: "人员号码",
    Please_enter_your_phone_number: "请输入电话号码",
    Please_save_and_distribute_the_device: "请保存后下发设备",
    Please_select_the_faulty_circuit: "请选择故障线路",
    Please_select_the_faulty_phase: "请选择故障相",
    Please_select_the_fault_interval: "请选择故障区间",
    Issued_successfully: "下发成功",
    Please_enter_the_processor: "请输入处理人",
    station: "站点",
    line: "线路",
    equipment: "设备",
    type: "类型",
    grounding: "接地",
    short_circuit: "短路",
    power_outage: "停电",
    Main_station_time: "主站时间",
    Select_line: "选择线路",
    Select_device: "选择设备",
    Point_selection: "点位选择",
    time_range: "时间范围",
    Fault_frequency_reminder: "故障次数提醒",

    exportbtn: "导出",
    importbtn: "导入",
    realdatabtn: "实时数据",
    returnbtn: "返回",
    configuration: "配置",
    linelabel: "线路",
    daterangelab: "日期范围",
    begindate: "开始日期",
    enddate: "结束日期",
    devnamelab: "设备名称",
    devnametit: "请输入设备名称",
    devwarnStatelab: "告警状态",
    devwarnstateopton1: "不限",
    devwarnstateopton2: "复归",
    devwarnstateopton3: "动作",
    emportsuccessmsg: "导出成功",
    exportfailed: "导出失败",
    substation: "变电站",
    nodatatit: "暂无数据",
    addedsuccessful: "新增成功",
    modifiedsuccessful: "修改成功",
    deletesuccessful: "删除成功",
    savesuccessful: "保存成功",
    downloadsuccessful: "下载成功",
    refresh_cache: "刷新配置缓存"
  },
  soevue: {
    soetable: {
      serial: "序号",
      warntime: "告警时间",
      linename: "线路",
      devname: "设备名称",
      alarmcontent: "告警内容"
    }
  },
  statistic: {
    year: "近一年",
    sixmonths: "近半年",
    onemonth: "近一个月",
    week: "近一周",
    times: "次",
    faultanalysisstatistics: "故障分析统计",
    faultanalysis: "故障次数分析",
    accumulatedcount: "累计故障次数",
    groundfault: "接地故障",
    shortcircuitfault: "短路故障",
    outagefault: "停电故障",
    faultverification: "故障核实情况统计",
    groundingfaults: "线路接地故障次数",
    notverified: "未核实",
    verified: "已核实"
  },
  statisticdevice: {
    exportonlinerate: "导出在线率",
    onexportbydevice: "导出设备日志",
    equipmentonlinerate: "设备在线率(/次)",
    dataintegrityrate: "数据完整率(/%)",
    equipmentonlineratelist: "设备在线率列表",
    onlineratetab: {
      archives_name: "现场名称",
      device_name: "设备类型",
      onlinetime_max: "最大在线时长",
      onlinetime_all: "总计在线时长",
      offlinetime_max: "最大掉线时长",
      last_onlinetime: "最后登录时间",
      offlinetime_all: "总计离线时长",
      online_rate: "在线率",
      online_count: "上线次数"
    }
  },
  insulation: {
    table: {
      serial: "序号",
      linename: "线路",
      createtime: "创建时间",
      Insulationmessages: "绝缘预警信息"
    },
    insulationwarningrule: "绝缘预警--规则配置",
    dailyexceeding: "每日超过",
    weeklyexceeding: "每周超过",
    monthlyexceeding: "每月超过",
    insulationwarningoccurs: "次接地故障，发生绝缘预警"
  },
  report: {
    month: "月报",
    week: "周报",
    date: "日报",
    customdate: "自定义时间段",
    PlatformName: "聚能谷设备服务",
    analysisreport: "站点统计分析报告",
    group_name: "长沙恒电聚能电子科技有限公司",
    basic: "基本信息",
    nickName: "用户名",
    dateTypeText: "报告类型",
    statisticsdate: "统计时间",
    currentDate: "生成日期",
    format: "yyyy 年 MM 月 dd 日",
    format1: "yyyy 第 WW 周",
    format2: "yyyy 年 MM 月",
    lastweek: "最近一周",
    lastmonth: "最近一个月",
    lastthreemonths: "最近三个月",
    analysisreport: "分析报告"
  },
  smslog: {
    table: {
      serial: "序号",
      content: "短信内容",
      user_phones: "用户电话",
      sendstatus: "发送状态",
      success: "成功",
      fail: "失败",
      create_time: "创建时间"
    }
  },
  converting: {
    filterText: "输入关键字进行搜索",
    devform: {
      id: "设备编号",
      manufacturer: "厂家",
      device_model: "设备型号",
      longitude: "终端经度",
      software_version: "软件版本",
      operation: "是否投运",
      can_lb: "能否录波",
      notit: "否",
      yestit: "是",
      communication_port: "通讯端口",
      sim_iccid: "IM卡ICCID号",
      Main_sim_iccid: "主SIM卡ICCID号",
      Backup_sim_iccid: "备SIM卡ICCID号",
      Main_MSISDN_card: "主MSISDN卡",
      Prepare_MSISDN_card: "备MSISDN卡",
      communication_type: "通讯类型",
      type1: "TCP客户端",
      type2: "UDP客户端",
      terminal_id: "终端ID",
      terminal_name: "终端名称",
      name1: "架空暂态录波型",
      name2: "电缆稳态录波型",
      device_type: "设备类型",
      devtype1: "边缘子站",
      devrype2: "故障指示器",
      latitude: "终端纬度",
      hardware_version: "硬件版本",
      str_link_addr: "链路地址",
      linkaddrtit: "十六进制",
      pointTable: "点表",
      sim_ipaddr: "SIM卡IP地址",
      protocol_type: "协议类型",
      protype1: "101平衡模式",
      diagramcfg: "线路图配置",
      leveltype: "设备级别",
      lvl1: "一级",
      lvl2: "二级",
      lvl3: "三级",
      parent_location: "设备父级",
      tower: "杆塔",
      sort: "排序号",
      towercfg: "杆塔配置",
      front: "前杆塔",
      after: "后杆塔",
      cablecfg: "电缆间隔配置",
      cabletype: "间隔类型",
      cable1: "1进3出",
      cable2: "2进4出",
      cable3: "2进6出",
      cablelist: "间隔列表",
      linename: "线路名称",
      pointTableattribute: "点表属性"
    },
    placeholder: "请选择",
    pointattr1: "第",
    pointattr2: "路",
    linkaddrtit1: "请输入链路地址",
    linkaddrtit2: "链路地址不能超过FFFF",
    parsetit: "解析错误",
    teridtit: "请输入终端ID",
    ternametit: "请选择终端名称",
    devtypetit: "请选择设备类型",
    comtypetit: "请选择通讯类型",
    protypetit: "请选择协议类型",
    pointtit: "请选择点表",
    simaddrtit: "长度不超过16个字符",
    parenttit: "请选择设备父级",
    sorttit: "请选择排序号",
    route2: "第二路",
    route3: "第三路",
    route4: "第四路",
    route5: "第五路",
    appendtitle: "新增",
    editortitle: "编辑",
    removetitle: "确定要删除吗?",
    removepc: "提示",
    placeholder: "请输入变电站名称",
    confirmbtn: "确定",
    cancelbtn: "取消",
    inputerrmsg: "不能为空"
  },
  pointdot: {
    pointname: "点表名称",
    placeholder: "请输入点表名称",
    placeholder1: "请输入单位",
    placeholder2: "请输入方法倍数",
    placeholder3: "请输入地址",
    placeholder4: "请上传导入文件",
    table: {
      name: "点表名称",
      unit: "单位",
      accuracy: "方法倍数",
      straddr: "地址",
      inneraddr: "内部地址",
      create_time: "创建时间"
    },
    warningmsg: "请先选中数据",
    tic: "提示",
    deletemsg: "删除后不可恢复，确定要删除选中的数据吗？",
    appendtitle: "新增",
    editortitle: "编辑",
    removetitle: "确定要删除吗?",
    confirmbtn: "确定",
    cancelbtn: "取消",
    inputerrmsg1: "不能为空",
    inputerrmsg2: "不能有特殊字符",
    detailview: "详情页面",
    mubtit: "模板",
    mubanemporttit: "下载导入模板",
    emportPointinfotit: "系统内部点表信息",
    importfilepathstit: "上传文件",
    upload__text: "将文件拖到此处，或",
    upload__text1: "点击上传",
    upload__tip: "只支持XML文件导入",
    uploaderror: "上传文件大小不能超过 5MB!",
    uploaderror1: "文件上传失败",
    uploadsuccess: "文件上传成功",
    uploadwarning: "当前限制选择1个文件",
    uploadmsg: "确定移除该文件？",
    confirm_removal: "确定移除 "
  },
  verifyfault: {
    table: {
      serial: "序号",
      route_umber: "线路编号",
      archive_name: "线路名称",
      deployment_location: "部署位置",
      Defect_Type: "缺陷类型",
      Diagnostic_timing: "诊断时刻",
      fault_type: "故障类型",
      fault_type1: "接地故障",
      fault_type2: "短路故障",
      fault_type3: "停电故障",
      fault_typedesc: "故障详情",
      faultlocation: "故障定位",
      fault_time: "故障时间",
      verification_status: "核实结果",
      verification_status1: "判断失误",
      verification_status2: "判断准确",
      verification_status3: "不明确是否发生此故障",
      handle_user_name: "处理人",
      handle_content: "处理概况",
      handle_time: "处理时间",
      handle_status: "处理状态",
      handle_status1: "未处理",
      handle_status2: "已处理",
      handbtn: "处理",
      handimgbtn: "查看附件",
      imgtit: "附件图片集",
      checkedNum: "已处理核实",
      noCheckedNum: "未处理核实",
      editStatus: "编辑核实状态",
      result: "核实结果",
      result1: "判断失误",
      result2: "判断准确",
      handleInfo: "处理情况",
      placeholder: "请输入现场核实发现的情况",
      placeholder1: "请选择核实结果",
      placeholder2: "请输入处理情况",
      placeholder3: "请选择处理人",
      handler: "处理人员",
      handlerimgs: "上传附件",
      confirmbtn: "确定",
      cancelbtn: "取消",
      handsuccess: "处理成功"
    }
  },
  groupmanage: {
    gname: "名称",
    placeholder: "请输入名称",
    placeholder1: "请输入平台名称",
    placeholder2: "请输入短信KeyID",
    placeholder3: "请输入短信KeySecret",
    placeholder4: "请输入短信签名",
    placeholder5: "请输入短信模板Code",
    placeholder6: "请上传平台logo",
    table: {
      serial: "序号",
      group_name: "集团名称",
      PlatformName: "平台名称",
      SMSaccessKeyId: "短信KeyID",
      SMSaccessKeySecret: "短信KeySecret",
      SMSSignName: "短信签名",
      SMSTemplateCode: "短信模板Code",
      create_time: "创建时间",
      platformLogo: "平台logo"
    },
    tic: "提示",
    appendtitle: "新增",
    editortitle: "编辑",
    removetitle: "确定要删除吗?",
    confirmbtn: "确定",
    cancelbtn: "取消"
  },
  settingmanage: {
    serial: "序号",
    substation_name: "变电站名称",
    is_use: "规则启用",
    select_tips: "请选择",
    is_use0: "未启用",
    is_use1: "已启用",
    Status0: "禁用",
    Status1: "启用",
    not_send_sms0: "未开启",
    not_send_sms1: "已开启",
    not_send_sms: "波形接地短信全拦",
    not_call_phone: "波形接地电话拦截",
    repeat_term: "重复拦截期",
    create_time: "创建时间",
    repeat_term_af: "分钟内，重复的不发",
    confirmbtn: "确定",
    cancelbtn: "取消",
    enatit1: "是否禁用该配置？",
    enatit2: "是否启用该配置？",
    opsuccess: "操作成功",
    tic: "提示"
  },
  usermanage: {
    serial: "序号",
    account: "账号",
    password: "密码",
    username: "用户名",
    Role_name: "用户角色",
    Group_name: "所属集团",
    phone: "手机号",
    Status: "用户状态",
    Status1: "全部",
    Status2: "正常",
    Status3: "禁用",
    Status4: "启用",
    CreateTime: "创建时间",
    isUpdatemsg: "是否修改密码",
    checkedRoles: "所属角色",
    isSmsPush: "短信推送",
    Region: "拥有区域",
    all: "全选",
    placeholder: "请输入账号",
    placeholder1: "请输入用户名",
    placeholder2: "请输入手机号",
    placeholder3: "请输入密码",
    placeholder4: "格式错误，请输入正确的手机号",
    placeholder5: "请输入正确的手机号",
    placeholder6: "请选择角色",
    placeholder7: "密码不能为空格",
    placeholder8: "密码长度需大于或等于6位数",
    confirmbtn: "确定",
    cancelbtn: "取消",
    tic: "提示",
    deletetit: "是否删除该用户？",
    enatit1: "是否禁用该用户？",
    enatit2: "是否启用该用户？",
    opsuccess: "操作成功"
  },
  rolemanage: {
    serial: "序号",
    Name: "角色名称",
    Group_name: "所属集团",
    Status: "状态",
    Status1: "全部",
    Status2: "正常",
    Status3: "禁用",
    CreateTime: "创建时间",
    roleDesc: "角色描述",
    allocation1: "为角色",
    allocation2: "分配菜单",
    placeholder: "请输入角色名称",
    placeholder1: "请输入角色描述",
    placeholder2: "不能为空",
    tic: "提示",
    appendtitle: "新增",
    editortitle: "编辑",
    removetitle: "确定要删除吗?",
    confirmbtn: "确定",
    cancelbtn: "取消",
    assginsuccess: "分配成功"
  },
  menusmanage: {
    name: "菜单名称",
    parentName: "父级菜单",
    parentNamedata: "根节点",
    icon: "图标",
    not: "无",
    sel: "选择",
    url: "url地址",
    sort: "排序号",
    isShow: "是否显示",
    placeholder: "请输入菜单名称",
    placeholder1: "请输入url地址",
    placeholder2: "请输入排序号",
    tic: "提示",
    removetitle: "确定要删除吗?",
    confirmbtn: "确定",
    cancelbtn: "取消"
  },
  feedback: {
    serial: "序号",
    uname: "用户名",
    uphone: "联系号码",
    backcontent: "反馈内容",
    create_time: "反馈时间",
    handimgbtn: "查看附件",
    imgtit: "附件图片集"
  },
  systemlog: {
    titlelab: "标题/内容",
    title: "标题",
    logType: "日志类型",
    AppName: "应用名称",
    Content: "日志内容",
    Uname: "用户名",
    timespan: "时间",
    TraceId: "链路标识"
  },
  topovue: {
    toptitle: "接线拓扑图",
    RealRefresh: "实时刷新",
    savePosition: "保存位置",
    savePositionmsg: "保存成功",
    nodata: "暂无数据",
    closeChart: "返回",
    trendchart: "点位趋势图",
    generalcall: "设备总召",
    recordingfile: "录波文件",
    generaltimecs: "当前数据总召时间",
    GeneralCall: "数据总召",
    GetGeneralCall: "数据更新",
    yc: "遥测",
    yx: "遥信",
    fg: "复归",
    dz: "动作",
    Readfiles: "读取录波文件",
    Preview: "在线预览",
    Downloadfiles: "下载到本地",
    file_name: "文件名称",
    file_addr: "文件地址",
    read_state: "读取状态",
    read_state1: "读取失败",
    read_state2: "读取完成",
    read_time: "读取时间",
    recordchartcstit: "设备录波文件分析",
    GeneralCallmsg: "正在召测设备数据，请1分钟后查询结果",
    Readfilesmsg: "正在读取录波文件，请3~5分钟后查询结果",
    Previewmsg1: "请选择至少一条文件数据",
    Previewmsg2: "每次只能预览一个文件,请选择一条文件数据"
  },
  fault: {
    FaultAnalysisNotification: "故障分析通知"
  },
  alls: {
    home1: "投运",
    hometit1: "故障分析通知",
    hometab1: "故障时刻",
    hometab2: "故障变电站",
    hometab3: "故障线路",
    hometab4: "故障相",
    hometab5: "自动判断区间",
    hometab6: "创建时间",
    hometab7: "设备数",
    hometab8: "系统判定",
    lines1: "所属省/市",
    lines2: "对应项目",
    lines3: "变电站名称",
    lines4: "线路名称",
    lines4p: "请输入线路名称",
    linetopobtn1: "设备复归",
    linetopobtn2: "批量遥控录波",
    linetopodet1: "定值参数",
    linetopodet2: "遥控设置",
    det1btn0: "重启",
    det1btn1: "设备重启",
    det1btn2: "读取",
    det1btn3: "切换",
    det1btn4: "预置",
    det1btn5: "固化",
    det1btn6: "撤销",
    det1btn7: "点击上传",
    det1btn8: "读取全部",
    det1btn9: "刷新表格",
    det1int1: "定值区号",
    det1int2: "最大",
    det1int3: "最小",
    det1int4: "点号",
    det1int5: "类型",
    det1int6: "长度",
    det1int7: "值",
    det1tit0: "定值点号",
    det1tit1: "定值参数",
    det1tit2: "多个参数",
    det1tit3: "定值参数文件",
    det1tit4: "只能上传XML文件",
    det1tit5: "单个参数",
    det1tit6: "请填写十六进制数据",
    det1tab1: "参数地址",
    det1tab2: "参数名称",
    det1tab3: "参数内容",
    det1tab4: "单位",
    det1tab5: "类型",
    det2tit1: "遥控",
    det2tit2: "可操作状态",
    det2tit3: "选择状态值",
    det2btn1: "执行",
    soetit2: "告警内容",
    soetitp2: "请输入告警内容",
    soetitp3: "请输入定值点号",
    soetitp4: "请输入定值参数",
    soetab1: "变电站",
    equibtn1: "导出在线日志",
    phonelogtab1: "通知内容",
    phonelogtab2: "通知状态",
    subtit1: "名称",
    subtit2: "输入",
    subtit3: "选择"
  }
}
export default zh
